import { parse } from "qs";

import { Query } from "custom-types/Query";

const parseNextRouterAsPath = <T = Query>(asPath: string) => {
  const [url, hash] = asPath.split("#");
  const [path, query] = url.split("?");

  return { hash, path, query: parse(query) as T };
};

export default parseNextRouterAsPath;
